import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { LoggingService } from './global';
import { environment } from './environments/environment';

window.Log = {
  message: LoggingService.log,
  error: LoggingService.error,
  warn: LoggingService.warn,
  info: LoggingService.info,
  debug: LoggingService.debug,
};

const loadDesignSystem = () =>
  Promise.all([
    import('@cmsgov/design-system/dist/web-components/bundle/base.js'),
    import('@cmsgov/design-system/dist/web-components/bundle/ds-button.js'),
    import('@cmsgov/design-system/dist/web-components/bundle/ds-text-field.js'),
    import('@cmsgov/design-system/dist/web-components/bundle/ds-dropdown.js'),
    import('@cmsgov/design-system/dist/web-components/bundle/ds-choice.js'),
    import('@cmsgov/design-system/dist/web-components/bundle/ds-date-field.js'),
  ]).catch(err => Log.warn('Design system load failed', err));

const faviconHref = environment.production ? 'favicon.ico' : 'favicon-angular.ico';
const faviconElement = document.getElementById('app-favicon') as HTMLLinkElement | null;
if (faviconElement) {
  faviconElement.href = faviconHref;
}

bootstrapApplication(App, appConfig)
  .then(() => loadDesignSystem())
  .catch(err => Log.error(err));
